export const lowercase = {
  // eslint-disable-next-line no-unused-vars
  bind(el, _, vnode) {
    el.addEventListener('input', e => {
      e.target.value = e.target.value.toLowerCase()
    })
  },
}
export const _ = null
